<div class="completed-orders" (scroll)="onScroll($event)">
  <mat-form-field class="search-completed-orders">
    <input matInput placeholder="Search" autocomplete="off" [formControl]="completedOrdersSearch" />
  </mat-form-field>
  <div
    *ngFor="let meshCount of meshCounts$ | async; trackBy: meshCounts$ | trackByKey: 'meshName'"
    class="flex justify-between px-2 pb-1 text-gray-700"
  >
    <div>{{ meshCount.meshName }} Mesh</div>
    <div>{{ meshCount.count }} completed order(s)</div>
  </div>
  <div class="order-list">
    <ng-container *ngFor="let header of headersWithOrders$ | async; trackBy: headersWithOrders$ | trackByKey: 'name'">
      <div class="group-header">
        <span>{{ header.name }}</span>
        <span>{{ header.count | i18nPlural: loadPluralMapping }}</span>
      </div>
      <sa-order-summary
        *ngFor="let orderSummary of header.orders; trackBy: header.orders | trackByKey: 'id'"
        [isCompleted]="header.isCompleted"
        [orderSummary]="orderSummary"
        [link]="['../', orderSummary.id]"
      ></sa-order-summary>
    </ng-container>
  </div>
</div>
